import service from "@/store/services/member-notes-service";

const mutations = {
  SET_RESOURCE: (state, member_note) => {
    state.member_note = member_note;
  }
};

const actions = {
  add({ commit, dispatch }, params) {
    return service.add(params).then(member_note => {
      commit("SET_RESOURCE", member_note);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params).then(member_note => {
      commit("SET_RESOURCE", member_note);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params);
  }
};

const member_notes = {
  namespaced: true,
  actions,
  mutations
};

export default member_notes;
